import { Mars, Venus } from "lucide-react";
import { genderLabel } from "./labels";

const GENDER_ICONS: Record<string, { Icon: typeof Mars; color: string }> = {
  MALE: { Icon: Mars, color: "text-blue-500" },
  FEMALE: { Icon: Venus, color: "text-pink-500" },
};

interface GenderColumnCellProps {
  gender?: string;
}

// Mirrors CountryColumnCell: icon + label. "ANY" (the vet couldn't tell)
// and missing both render as a dash, like an unknown country does.
export default function GenderColumnCell({ gender }: GenderColumnCellProps) {
  const entry = gender ? GENDER_ICONS[gender.toUpperCase()] : undefined;
  if (!entry) {
    return (
      <div className="text-[13px] pr-2 text-muted-foreground" title={gender ? "Not determined" : undefined}>
        -
      </div>
    );
  }
  const { Icon, color } = entry;
  return (
    <div className="flex flex-row items-center gap-1.5 text-[13px] pr-2">
      <Icon className={`size-3.75 shrink-0 ${color}`} aria-hidden="true" />
      <span className="truncate leading-5">{genderLabel(gender)}</span>
    </div>
  );
}
